import { render, staticRenderFns } from "./bggl.vue?vue&type=template&id=49689d0b&scoped=true"
import script from "./bggl.vue?vue&type=script&lang=js"
export * from "./bggl.vue?vue&type=script&lang=js"
import style0 from "./bggl.vue?vue&type=style&index=0&id=49689d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49689d0b",
  null
  
)

export default component.exports